// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageUseesPlaceholderPopup_popup_body__TgitT {
  /* display: flex;
  align-items: center;
  justify-content: space-evenly; */
}
.ImageUseesPlaceholderPopup_image_option__L8D72 {
  display: flex;
  align-items: center;
  /* justify-content: space-evenly; */
}
.ImageUseesPlaceholderPopup_image_check__Iuz7A {
  width: 10%;
}
.ImageUseesPlaceholderPopup_image_text__qaBUW {
  width: 100%;
}
.ImageUseesPlaceholderPopup_left_body__dFkn4 {
  width: 30%;
}
.ImageUseesPlaceholderPopup_right_body__VjYrX {
  width: 30%;
}
.ImageUseesPlaceholderPopup_subheader__0aIvN {
  margin-top: 10px;
  margin-bottom: 10px;
}
.ImageUseesPlaceholderPopup_explainatory_text__Lotl3 {
  margin-top: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/ImageUsesPlaceholderPopup/ImageUseesPlaceholderPopup.module.css"],"names":[],"mappings":"AAAA;EACE;;kCAEgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".popup_body {\n  /* display: flex;\n  align-items: center;\n  justify-content: space-evenly; */\n}\n.image_option {\n  display: flex;\n  align-items: center;\n  /* justify-content: space-evenly; */\n}\n.image_check {\n  width: 10%;\n}\n.image_text {\n  width: 100%;\n}\n.left_body {\n  width: 30%;\n}\n.right_body {\n  width: 30%;\n}\n.subheader {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.explainatory_text {\n  margin-top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup_body": `ImageUseesPlaceholderPopup_popup_body__TgitT`,
	"image_option": `ImageUseesPlaceholderPopup_image_option__L8D72`,
	"image_check": `ImageUseesPlaceholderPopup_image_check__Iuz7A`,
	"image_text": `ImageUseesPlaceholderPopup_image_text__qaBUW`,
	"left_body": `ImageUseesPlaceholderPopup_left_body__dFkn4`,
	"right_body": `ImageUseesPlaceholderPopup_right_body__VjYrX`,
	"subheader": `ImageUseesPlaceholderPopup_subheader__0aIvN`,
	"explainatory_text": `ImageUseesPlaceholderPopup_explainatory_text__Lotl3`
};
export default ___CSS_LOADER_EXPORT___;
